import Loading from '@/common/components/Loading';
import CandidateForm from '@/pages/admin/recruitment/components/CandidateForm';
import CandidatesTable from '@/pages/admin/recruitment/components/CandidatesTable';
import RecruitmentManagerSearchBar from './components/RecruitmentManagerSearchBar';
import useRecruitmentManager from './hooks/useRecruitmentManager';
import { TableContainer, TableWrapper } from './RecruitmentManager.styled';

const RecruitmentManager = () => {
	const hook = useRecruitmentManager();

	return (
		<div>
			{hook.isLoading && <Loading />}
			<RecruitmentManagerSearchBar
				candidates={hook.callCenterCandidates}
				setVisibleCandidates={hook.setVisibleCandidates}
				setShowCandidateForm={hook.setShowCandidateForm}
			/>
			<TableContainer>
				<TableWrapper>
					<CandidatesTable
						setShowCandidateForm={hook.setShowCandidateForm}
						candidates={hook.visibleCandidates}
					/>
				</TableWrapper>
			</TableContainer>
			{hook.showCandidateForm && (
				<CandidateForm
					callCenterPositionsOptions={hook.callCenterPositionsOptions}
					setShow={hook.setShowCandidateForm}
					selectedCandidate={hook.showCandidateForm}
					reload={hook.loadCandidates}
				/>
			)}
		</div>
	);
};

export default RecruitmentManager;
